
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SendHorizonal } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

export const ModelSettings = () => {
  const [selectedModel, setSelectedModel] = useState("llama4");
  const { toast } = useToast();
  
  const handleModelChange = (value: string) => {
    setSelectedModel(value);
    toast({
      title: "Model Updated",
      description: `Now using ${value === "llama4" ? "Stewie with Llama 4" : "Claude 3.5"}`,
      variant: "success",
    });
  };
  
  const handleExplainPortfolio = () => {
    toast({
      title: "Analyzing Portfolio",
      description: `Using ${selectedModel === "llama4" ? "Stewie with Llama 4" : "Stewie with Claude 3.5"} to analyze your portfolio`,
      variant: "primary",
    });
  };
  
  return (
    <div className="rounded-lg border bg-white p-6">
      <h3 className="font-semibold mb-4">AI Model Settings</h3>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Select Language Model</Label>
          <Select value={selectedModel} onValueChange={handleModelChange}>
            <SelectTrigger className="w-full rounded-md">
              <SelectValue placeholder="Select a model" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="llama4">Stewie with Llama 4 (Default)</SelectItem>
              <SelectItem value="gemini">Stewie with Claude 3.5</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button 
          className="w-full rounded-[4px] bg-[#221F26] hover:bg-[#403E43] text-white transition-all duration-200 shadow-sm hover:shadow-md transform hover:-translate-y-0.5"
          onClick={handleExplainPortfolio}
        >
          <SendHorizonal className="h-4 w-4 mr-2" />
          Explain My Portfolio
        </Button>
      </div>
    </div>
  );
};
